import * as React from "react";

import { cn } from "@/lib/utils";

function Table({ className, ...props }: React.ComponentProps<"table">) {
    return (
        <div data-slot="table-container" className="setu:relative setu:w-full setu:overflow-x-auto">
            <table
                data-slot="table"
                className={cn("setu:w-full setu:caption-bottom setu:text-sm", className)}
                {...props}
            />
        </div>
    );
}

function TableHeader({ className, ...props }: React.ComponentProps<"thead">) {
    return <thead data-slot="table-header" className={cn("setu:[&_tr]:!border-b", className)} {...props} />;
}

function TableBody({ className, ...props }: React.ComponentProps<"tbody">) {
    return <tbody data-slot="table-body" className={cn("setu:[&_tr:last-child]:!border-0", className)} {...props} />;
}

function TableFooter({ className, ...props }: React.ComponentProps<"tfoot">) {
    return (
        <tfoot
            data-slot="table-footer"
            className={cn("setu:bg-muted/50 setu:!border-t setu:font-medium setu:[&>tr]:last:!border-b-0", className)}
            {...props}
        />
    );
}

function TableRow({ className, ...props }: React.ComponentProps<"tr">) {
    return (
        <tr
            data-slot="table-row"
            className={cn(
                "setu:hover:bg-muted/50 setu:data-[state=selected]:bg-muted setu:!border-b setu:transition-colors",
                className
            )}
            {...props}
        />
    );
}

function TableHead({ className, ...props }: React.ComponentProps<"th">) {
    return (
        <th
            data-slot="table-head"
            className={cn(
                "setu:text-foreground setu:h-10 setu:px-2 setu:text-left setu:align-middle setu:font-medium setu:whitespace-nowrap setu:[&:has([role=checkbox])]:pr-0 setu:[&>[role=checkbox]]:translate-y-[2px]",
                className
            )}
            {...props}
        />
    );
}

function TableCell({ className, ...props }: React.ComponentProps<"td">) {
    return (
        <td
            data-slot="table-cell"
            className={cn(
                "setu:p-2 setu:align-middle setu:whitespace-nowrap setu:[&:has([role=checkbox])]:pr-0 setu:[&>[role=checkbox]]:translate-y-[2px]",
                className
            )}
            {...props}
        />
    );
}

function TableCaption({ className, ...props }: React.ComponentProps<"caption">) {
    return (
        <caption
            data-slot="table-caption"
            className={cn("setu:text-muted-foreground setu:mt-4 setu:text-sm", className)}
            {...props}
        />
    );
}

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
